import api from "../../services/api";
import { gmapApi } from "vue2-google-maps";
import moment from "moment";
import formatcoords from "formatcoords";
import helpers from "../../shared/fleetbox-helpers";
import { Marker, GeoPosition, Polyline } from "../../domain/poi";
import { bus } from "../../main";
import marker from "vue2-google-maps/dist/components/marker";
import mapPoiCategoriesFilter from "../../components/map/poicategories.vue";
import trafficLayer from "../../components/map/viewtraffic.vue";
import { mapGetters } from "vuex";

export default {
	components: {
		mapPoiCategoriesFilter,
		trafficLayer
	},
	props: {
		mapCenterLocation: {
			type: Object,
			default: {
				lat: 0,
				lng: 0
			}
		},
		zoom: {
			type: Number,
			default: 12
		},
		debug: { type: Boolean, default: false },
		vehicleIdFilterFieldFormatted: String
	},
	data: function() {
		return {
			firstTimeIn: true,
			center: {},
			markers: [],
			eventMarkers: [],
			infoContent: "",
			infoWindowPos: null,
			infoWinOpen: false,
			currentMidx: null,
			infoOptions: {
				content: "",
				pixelOffset: {
					width: 0,
					height: -35
				}
			},

			markersShown: [],
			pathsData: [],
			paths: [],

			//POI
			poiAreas: [],
			poiPaths: [],
			poiMarkers: [],

			//TRIP POIS
			poiTripMarkers: [],
			poiTripPaths: [],
			poiTripAreas: [],

			//TRIP MARKER
			tripMarkers: [],

			viewSatellite: false,
			mapStylesOptions: [ 
				{
					featureType: "poi",
					stylers: [ 
						{ 
							visibility: "off" 
						} 
					] 
				} 
			],
			showPhoneNumber: false

		};
	},
	watch: {},
	created() {
		var self = this;

		if (this.settings) {
			if (this.settings.viewSatellite) {
				this.viewSatellite = this.settings.viewSatellite;
			}

			if (this.settings.show_phone_in_map) {
				this.showPhoneNumber = true;
			}
		}

		self.center = {
			lat: self.mapCenterLocation.lat,
			lng: self.mapCenterLocation.lng
		};

		bus.$on("on-trips-selected-row", self.onSelectedRow.bind(self));
		bus.$on("on-trips-show-path", self.addPath.bind(self));
		bus.$on("on-trips-update-path", self.updatePath.bind(self));
		bus.$on("on-trips-remove-path", self.removePath.bind(self));
		bus.$on("on-trips-filters-change", self.removeAllPaths.bind(self));
		bus.$on("trip-detail-selected-row", self.tripDetailRowselected.bind(self));
		bus.$on("poi-category-filter-change", self.onPoiCategoryFilterChange.bind(self));
		bus.$on("on-trips-show-diagnostic", self.addDiagnosticMarkers.bind(self));
		bus.$on("on-trips-remove-diagnostic", self.removeDiagnosticMarkers.bind(self));
		bus.$on("on-trips-show-alarms", self.addAlarmsMarkers.bind(self));
		bus.$on("on-trips-remove-alarms", self.removeAlarmsMarkers.bind(self));
		bus.$on("on-trips-show-pois", self.addPoisMarkers.bind(self));
		bus.$on("on-trips-remove-pois", self.removePoisMarkers.bind(self));
	},
	mounted() {
		/* poi categories */
		var self = this;
		if (this.settings && this.settings.viewPoi) {
			this.$nextTick(() => {
				self.$refs.map.$gmapApiPromiseLazy().then(res => {
					self.$refs.poiCatgeoriesFilter.loadControls(self.$refs.map);
				});
				//}, 1000);
			});
		}
		/* poi categories */

		/* traffic Layer */
		if (this.settings && this.settings.viewTraffic) {
			self.$refs.map.$gmapApiPromiseLazy().then(res => {
				self.$refs.map.$mapPromise.then(map => {
					var trafficLayer = new google.maps.TrafficLayer();
					self.$refs.trafficLayer.loadControls(self.$refs.map);
				});
			});
		}
		/* traffic Layer */
	},
	beforeDestroy() {
		var self = this;
		bus.$off("on-trips-selected-row");
		bus.$off("on-trips-show-path");
		bus.$off("on-trips-remove-path");
		bus.$off("on-trips-filters-change");
		bus.$off("trip-detail-selected-row");
		bus.$off("poi-category-filter-change", self.onPoiCategoryFilterChange.bind(self));
		bus.$off("on-trips-show-diagnostic");
		bus.$off("on-trips-remove-diagnostic");
		bus.$off("on-trips-show-alarms");
		bus.$off("on-trips-remove-alarms");
		bus.$off("on-trips-show-pois");
		bus.$off("on-trips-remove-pois");
	},
	/* metodi */
	methods: {
		markerOut() {
			helpers.deleteTooltip();
		},
		markerOver($event, m) {
			helpers.injectTooltip($event.rb, m.description);
		},
		displayPois: function(data) {
			var self = this;

			//items to remove - marker
			var itemsToRemove = [];
			for (let i = 0; i < this.poiMarkers.length; i++) {
				var m = this.poiMarkers[i];
				let dataItem = _.find(data, d => {
					return d.id == m.id;
				});

				if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			}

			itemsToRemove.forEach(r => {
				let index = self.poiMarkers.findIndex(function(o) {
					return o.id == r;
				});

				self.poiMarkers.splice(index, 1);
			});

			//items to remove - polygon
			itemsToRemove = [];
			for (let i = 0; i < this.poiPaths.length; i++) {
				var m = this.poiPaths[i];
				let dataItem = _.find(data, d => {
					return d.id == m.id;
				});

				if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			}

			itemsToRemove.forEach(r => {
				let index = self.poiPaths.findIndex(function(o) {
					return o.id == r;
				});

				self.poiPaths.splice(index, 1);
			});

			//items to remove - area
			itemsToRemove = [];
			for (let i = 0; i < this.poiAreas.length; i++) {
				var m = this.poiAreas[i];
				let dataItem = _.find(data, d => {
					return d.id == m.id;
				});

				if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			}

			itemsToRemove.forEach(r => {
				let index = self.poiAreas.findIndex(function(o) {
					return o.id == r;
				});

				self.poiAreas.splice(index, 1);
			});

			data.forEach(function(item) {
				if (item.location.rendering_type == "marker" || (item.location.rendering_type == "unknown" && item.location.points.length == 1)) {
					let m = _.find(self.poiMarkers, function(o) {
						return o.id == item.id;
					});

					if (m == null) {
						m = new google.maps.Marker();
						m.id = item.id;
						m.infoWindowOptions = {
							infoWindowOpened: false,
							pixelOffset: {
								width: 0,
								height: -40
							}
						};

						self.poiMarkers.push(m);
					}

					m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
					m.description = item.name;
					m.info = `<b>${item.name}</b><br />
								LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
								INDIRIZZO: ${item.location.address}<br />`;

					if (item.poi_category_icon_image) {
						var icon = {
							url: item.poi_category_icon_image,
							scaledSize: new google.maps.Size(30, 36), // scaled size
							origin: new google.maps.Point(0, 0) // origin
						};
						m.icon = icon;
					}
					m.infoWindowOptions.content = m.info;
				} else if (item.location.rendering_type == "polygon" || (item.location.rendering_type == "unknown" && item.location.points.length > 1)) {
					//marker related to polygon
					if (!self.isInEditMode) {
						let m = _.find(self.poiMarkers, function(o) {
							return o.id == item.id;
						});

						if (m == null) {
							m = new google.maps.Marker();
							m.id = item.id;
							m.infoWindowOptions = {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: -40
								}
							};

							self.poiMarkers.push(m);
						}

						m.draggable = false;
						m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
						m.description = item.name;
						m.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
						if (item.poi_category_icon_image) {
							var icon = {
								url: item.poi_category_icon_image,
								scaledSize: new google.maps.Size(30, 36), // scaled size
								origin: new google.maps.Point(0, 0) // origin
							};
							m.icon = icon;
						}
						m.infoWindowOptions.content = m.info;
					}

					//polygon
					let p = _.find(self.poiPaths, function(o) {
						return o.id == item.id;
					});

					if (p == null) {
						p = {
							id: item.id,
							path: item.location.points.map(function(pt) {
								return new GeoPosition(pt.lat, pt.lon);
							}),
							infoWindowOptions: {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: 0
								}
							}
						};

						self.poiPaths.push(p);
					}

					p.fillColor = item.poi_category_fill_color;
					p.description = item.name;
					p.info = `<b>${item.name}</b><br />
									LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									INDIRIZZO: ${item.location.address}<br />`;
					p.infoWindowOptions.content = p.info;
				} else if (item.location.rendering_type == "circle") {
					//marker related to circle
					if (!self.isInEditMode) {
						let m = _.find(self.poiMarkers, function(o) {
							return o.id == item.id;
						});

						if (m == null) {
							m = new google.maps.Marker();
							m.id = item.id;
							m.infoWindowOptions = {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: -40
								}
							};

							self.poiMarkers.push(m);
						}

						m.draggable = item.draggable;
						m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
						m.description = item.name;
						m.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
						if (item.poi_category_icon_image) {
							var icon = {
								url: item.poi_category_icon_image,
								scaledSize: new google.maps.Size(30, 36), // scaled size
								origin: new google.maps.Point(0, 0) // origin
							};
							m.icon = icon;
						}
						m.infoWindowOptions.content = m.info;
					}
					//area
					let a = _.find(self.poiAreas, function(o) {
						return o.id == item.id;
					});

					if (a == null) {
						a = new google.maps.Circle();
						a.id = item.id;
						a.radius = item.radius;
						a.infoWindowOptions = {
							infoWindowOpened: false,
							pixelOffset: {
								width: 0,
								height: 0
							}
						};

						self.poiAreas.push(a);
					}
					a.center = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
					a.fillColor = item.poi_category_fill_color;
					a.description = item.name;
					a.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
					a.infoWindowOptions.content = a.info;
				}
			});
		},
		poiMarkerClick: function(marker) {
			helpers.deleteTooltip();
			this.hideAllInfoWindow();
			this.toggleInfoWindow(marker);
		},
		onPoiCategoryFilterChange(items) {
			this.displayPois(items);
		},
		tripDetailRowselected(dataItem) {
			this.highlightPathSelected(dataItem.id);
		},
		highlightPathSelected(id) {
			var self = this;
			var bounds = new google.maps.LatLngBounds();

			//Select markers
			var markersPathSelected = this.markers.filter(function(m) {
				return m.id == id;
			});

			var markersDeleted = false;
			for (var i = 0; i < markersPathSelected.length; i++) {
				var mkr = markersPathSelected[i].id;

				var mkrIndex = this.markers.findIndex(function(m) {
					return m.id == mkr;
				});

				if (mkrIndex >= 0) {
					this.markers.splice(mkrIndex, 1);
					markersDeleted = true;
				}
			}

			this.markers.forEach(function(mk) {
				mk.zIndex = 0;
				if (mk.isStart) {
					mk.icon = {
						url: "/icon-start.png",
						scaledSize: new google.maps.Size(20, 33)
					};
				} else {
					mk.icon = {
						url: "/icon-end.png",
						scaledSize: new google.maps.Size(20, 33)
					};
				}
			});

			markersPathSelected.forEach(m => {
				if (m.isStart) {
					m.icon = {
						url: "/icon-start.png",
						scaledSize: new google.maps.Size(30, 50),
						origin: new google.maps.Point(0, 0)
					};
				} else {
					m.icon = {
						url: "/icon-end.png",
						scaledSize: new google.maps.Size(30, 50)
						//anchor: new google.maps.Point(5, 40)
					};
				}

				bounds.extend(m.position);
			});

			var self = this;
			if (markersDeleted) {
				for (var i = 0; i < markersPathSelected.length; i++) {
					var mkr = markersPathSelected[i];
					mkr.zIndex = 1;
					self.markers.unshift(mkr);
				}
			}

			//Select path
			var path = this.paths.find(function(p) {
				return p.id == id;
			});

			var pathIndex = this.paths.findIndex(function(p) {
				return p.id == id;
			});

			//remove path
			if (pathIndex >= 0) this.paths.splice(pathIndex, 1);

			this.paths.forEach(function(p) {
				p.linestrokeWeight = 2;
				p.strokeColor = "black";
			});

			if (path) {
				path.linestrokeWeight = 3;
				path.strokeColor = "#ff9359";

				if (path.path.length > 0) {
					path.path.forEach(element => {
						bounds.extend(element);
					});
				}
			}

			//re-add path
			if (pathIndex >= 0) this.paths.push(path);

			self.$refs.map.$mapPromise.then(map => {
				map.fitBounds(bounds);
			});
		},
		onSelectedRow(e) {
			if (e) {
				var self = this;
				var position = {
					lat: e.position.lat,
					lng: e.position.lon
				};
				this.centerMap(position);

				self.hideAllInfoWindow();
				self.markers.forEach(function(item, index) {
					if (item.id == e.vehicle_id) {
						item.infoWindowOptions.infoWindowOpened = true;
					}
				});
			}
		},
		removeMarkers: function(markersToRemove) {
			if (markersToRemove && markersToRemove.length > 0) {
				var idsToRemove = markersToRemove.map(function(x) {
					return x.trip_id;
				});

				for (var i = 0; i < idsToRemove.length; i++) {
					this.markers = this._.remove(this.markers, function(item) {
						item.id === idsToRemove[i].trip_id;
					});
				}
			}
		},
		fitAndZoom: function() {
			var self = this;

			// self.$gmapApiPromiseLazy().then(() => { ..... })

			var bounds = new google.maps.LatLngBounds();

			self.markers.forEach(function(item, index) {
				bounds.extend(item.position);
			});

			self.paths.forEach(function(p) {
				if (p.path.length > 0) {
					p.path.forEach(element => {
						bounds.extend(element);
					});
				}
			});

			if (self.$refs.map) {
				self.$refs.map.$mapPromise.then(map => {
					map.fitBounds(bounds);
					if (map.getZoom() >= 22) {
						map.setZoom(14);
					}
				});
			}
		},
		markerClick: function(marker, idx) {
			if (this.markers.length > 1 && marker.infoWindowOptions && marker.infoWindowOptions.infoWindowOpened) {
				//if is already open, search for other markers that have same coordinates
				var markersPathSamePosition = this.markers.filter(function(mm) {
					return mm.id != marker.id && mm.position && mm.position.lat == marker.position.lat && mm.position.lng == marker.position.lng;
				});
				var eventMarkersSamePosition = this.eventMarkers.filter(function(mm) {
					return mm.id != marker.id && mm.position && mm.position.lat == marker.position.lat && mm.position.lng == marker.position.lng;
				});

				var markersSamePosition = markersPathSamePosition.concat(eventMarkersSamePosition);

				if (markersSamePosition.length > 0) {
					var lastIndex = marker.infoWindowOptions.indexLoopSamePosition;
					var mToShow = markersSamePosition.find(function(item) {
						return item.infoWindowOptions.indexLoopSamePosition > lastIndex;
					});

					if (mToShow) {
						marker = mToShow;
					} else {
						marker = markersSamePosition[0];
					}
				}
			}

			this.markers.forEach(function(item, index) {
				item.zIndex = 0;
				if (item.id == marker.id) {
					item.zIndex = 1;
				}
			});

			this.eventMarkers.forEach(function(item, index) {
				item.zIndex = 0;
				if (item.id == marker.id) {
					item.zIndex = 1;
				}
			});

			if (marker.id.toString().indexOf("a_") < 0 && marker.id.toString().indexOf("d_") < 0) {
				this.highlightPathSelected(marker.id);
			}

			this.hideAllInfoWindow();

			this.toggleInfoWindow(marker);

			bus.$emit("on-marker-click", marker.id);
		},
		eventMarkerClick(marker) {
			if (this.eventMarkers.length > 1 && marker.infoWindowOptions && marker.infoWindowOptions.infoWindowOpened) {
				//if is already open, search for other markers that have same coordinates
				var markersPathSamePosition = this.markers.filter(function(mm) {
					return mm.id != marker.id && mm.position && mm.position.lat == marker.position.lat && mm.position.lng == marker.position.lng;
				});
				var eventMarkersSamePosition = this.eventMarkers.filter(function(mm) {
					return mm.id != marker.id && mm.position && mm.position.lat == marker.position.lat && mm.position.lng == marker.position.lng;
				});

				var markersSamePosition = markersPathSamePosition.concat(eventMarkersSamePosition);

				if (markersSamePosition.length > 0) {
					var lastIndex = marker.infoWindowOptions.indexLoopSamePosition;
					var mToShow = markersSamePosition.find(function(item) {
						return item.infoWindowOptions.indexLoopSamePosition > lastIndex;
					});

					if (mToShow) {
						marker = mToShow;
					} else {
						marker = markersSamePosition[0];
					}
				}
			}

			if (marker.id.toString().indexOf("a_") < 0 && marker.id.toString().indexOf("d_") < 0) {
				this.highlightPathSelected(marker.id);
			}

			this.hideAllInfoWindow();

			this.toggleInfoWindow(marker);

			this.markers.forEach(function(item, index) {
				item.zIndex = 0;
				if (item.id == marker.id) {
					item.zIndex = 1;
				}
			});

			this.eventMarkers.forEach(function(item, index) {
				item.zIndex = 0;
				if (item.id == marker.id) {
					item.zIndex = 1;
				}
			});
		},
		tripPoiMarkerClick: function(marker, idx) {
			this.poiTripMarkers.forEach(function(item, index) {
				item.zIndex = 0;
				if (item.id == marker.id) {
					item.zIndex = 1;
				}
			});

			this.hideAllInfoWindow();

			this.toggleInfoWindow(marker);
		},
		poiCategoriesMarkerClick: function(marker, idx) {
			this.hideAllInfoWindow();

			this.toggleInfoWindow(marker);
		},
		polylineClick(path) {
			this.highlightPathSelected(path.id);
			bus.$emit("on-marker-click", path.id);
		},
		hideAllInfoWindow: function() {
			var self = this;

			self.markers.forEach(function(item) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			self.eventMarkers.forEach(function(item) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			//POI
			self.poiMarkers.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			self.poiPaths.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			self.poiAreas.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			//TRIP POI MARKER
			self.poiTripMarkers.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			self.poiTripPaths.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			self.poiTripAreas.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});
		},
		showAllInfoWindow: function() {
			var self = this;

			self.markers.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = true;
			});
		},
		centerMap: function(position) {
			var self = this;

			self.$refs.map.$mapPromise.then(map => {
				map.setCenter(position);
			});
		},
		toggleInfoWindow: function(marker, idx) {
			marker.infoWindowOptions.infoWindowOpened = !marker.infoWindowOptions.infoWindowOpened;

			// this.infoWindowPos = marker.position;
			// this.infoContent = marker.info;
			// this.infoOptions.content = marker.info;
			// //check if its the same marker that was selected if yes toggle
			// if (this.currentMidx == idx) {
			// 	this.infoWinOpen = !this.infoWinOpen;
			// }
			// //if different marker set infowindow to open and reset current marker index
			// else {
			// 	this.infoWinOpen = true;
			// 	this.currentMidx = idx;
			// }
		},
		updatePath: function(dataItem) {
			var pathToUpdate = this.paths.find(function(p) {
				return p.id == dataItem.id;
			});

			if (pathToUpdate) {
				setTimeout(this.removePath(dataItem), 100);
				setTimeout(this.addPath(dataItem), 100);
			}
		},
		addPath: function(dataItem) {
			var alreadyExistsPath = this.paths.findIndex(function(p) {
				return p.id == dataItem.id;
			});

			if (alreadyExistsPath < 0) {
				//this.calculateAndDisplayRoute(dataItem.path);
				var points = helpers.decodeGooglePolyline(dataItem.path);

				var coordinates = points.map(function(item) {
					return {
						lat: item[0],
						lng: item[1]
					};
				});

				var mStart = new Marker();
				mStart.id = dataItem.id;
				mStart.number_plate = dataItem[this.vehicleIdFilterFieldFormatted];
				mStart.isStart = true;
				if (dataItem.first_start_location) {
					mStart.position.lat = dataItem.first_start_location.lat;
					mStart.position.lng = dataItem.first_start_location.lon;
				} else {
					mStart.position.lat = coordinates[0].lat;
					mStart.position.lng = coordinates[0].lng;
				}
				mStart.infoWindowOptions = {
					infoWindowOpened: false,
					pixelOffset: {
						width: 0,
						height: -40
					}
				};
				var tooltipInfo = `<b class="header">${dataItem.vehicle_name ? dataItem.vehicle_name : "---"} - ${dataItem[this.vehicleIdFilterFieldFormatted]}</b><br/>
								<b class="driver" style="color: #000">Conducente: ${dataItem.driver_name}</b><br/>
								${this.showPhoneNumber && dataItem.mobile_phone_number ? '<span class="blackColor">TEL.: </span><a target="_blank" href="https://api.whatsapp.com/send?phone=' + dataItem.mobile_phone_number + '">' + dataItem.mobile_phone_number + '</a><br/>': '<span class="blackColor">TEL.: </span>ND<br/>'}
								<div class="row mx-0 ttTable w-370 pd-a-10">
									<div class="col-xs-6 fs-10 lh-13 w-165">
										<i class="icon-start"></i><span class="blackColor">partenza:</span><br />
										<span class="lightGrey" style="margin-left: 13px">${dataItem.first_trip_start_date} - ${dataItem.first_trip_start_time}</span>
										<br/>
										<i class="icon-end"></i><span class="blackColor">arrivo:</span><br/>
										<span class="lightGrey" style="margin-left: 13px">${dataItem.last_trip_end_date} - ${dataItem.last_trip_end_time}</span>
									</div>
									<div class="col-xs-6 fs-10 lh-13 w-170">
										<span><span class="blackColor">tempo di guida:</span> <span class="lightGrey">${dataItem.drive_time}</span></span><br/>
										<span><span class="blackColor">tempo di sosta:</span> <span class="lightGrey">${dataItem.idle_time || "assenti"}</span></span><br/>
										<span><span class="blackColor">velocità media:</span> <span class="lightGrey">${dataItem.avg_speed != "(*)" ? `${parseInt(dataItem.avg_speed)} km/h` : dataItem.avg_speed} </span></span><br/>
										<span><span class="blackColor">velocità massima:</span> <span class="lightGrey">${dataItem.max_speed != "(*)" ? `${parseInt(dataItem.max_speed)} km/h` : dataItem.avg_speed} </span></span><br/>
										<span><span class="blackColor">TOT KM:</span> <span class="lightGrey">${
											dataItem.interpolated_trip_km != "(*)"
												? `${kendo.toString(dataItem.interpolated_trip_km_value, "n2")} km`
												: dataItem.path_trip_km != "(*)"
												? `${kendo.toString(dataItem.path_trip_km_value, "n2")} km`
												: dataItem.interpolated_trip_km
										} </span></span><br/>
										<span><span class="blackColor">TOT LT:</span> <span class="lightGrey">${
											dataItem.interpolated_trip_lt == "(*)" ? dataItem.interpolated_trip_lt : `${kendo.toString(dataItem.interpolated_trip_lt, "n2")} lt`
										}</span></span><br/>
									</div>
								</div>`;
				mStart.info = tooltipInfo;
				mStart.infoWindowOptions.content = mStart.info;
				mStart.icon = {
					url: "/icon-start.png",
					scaledSize: new google.maps.Size(20, 33)
				};
				mStart.description = "Partenza";
				this.markers.push(mStart);

				//add all marker related to all points in the path (except start and and)
				if (this.debug) {
					for (var i = 0; i < coordinates.length - 2; i++) {
						var mp = new Marker();
						mp.id = dataItem.id;
						mp.tripPoint = true;
						mp.position.lat = coordinates[i].lat;
						mp.position.lng = coordinates[i].lng;
						mp.icon = {
							path: google.maps.SymbolPath.CIRCLE,
							scale: 2
						};
						mp.infoWindowOptions = {
							infoWindowOpened: false,
							pixelOffset: {
								width: 0,
								height: -40
							}
						};
						mp.info = "";

						this.tripMarkers.push(mp);
					}
				}

				var mEnd = new Marker();
				mEnd.id = dataItem.id;
				mEnd.number_plate = dataItem[this.vehicleIdFilterFieldFormatted];
				mEnd.isStart = false;
				if (dataItem.last_end_location) {
					mEnd.position.lat = dataItem.last_end_location.lat;
					mEnd.position.lng = dataItem.last_end_location.lon;
				} else if (dataItem.last_known_location) {
					mEnd.position.lat = dataItem.last_known_location.lat;
					mEnd.position.lng = dataItem.last_known_location.lon;
				} else {
					mEnd.position.lat = coordinates[coordinates.length - 1].lat;
					mEnd.position.lng = coordinates[coordinates.length - 1].lng;
				}
				mEnd.infoWindowOptions = {
					infoWindowOpened: false,
					pixelOffset: {
						width: 0,
						height: -40
					}
				};
				mEnd.info = tooltipInfo;
				mEnd.infoWindowOptions.content = mEnd.info;
				mEnd.description = "Arrivo";
				mEnd.icon = {
					url: "/icon-end.png",
					scaledSize: new google.maps.Size(20, 33)
				};
				this.markers.push(mEnd);

				var line = new Polyline();
				line.id = dataItem.id;
				line.number_plate = dataItem[this.vehicleIdFilterFieldFormatted];
				line.path = coordinates;
				line.strokeColor = "black";
				line.strokeOpacity = 1.0;
				line.linestrokeWeight = 2;

				this.paths.push(line);

				this.fitAndZoom();
			}
		},

		addDiagnosticMarkers: function(data) {
			var self = this;

			var dataItem = data.dataItem;
			var diagnosticMarkers = data.diagnosticData;

			diagnosticMarkers.forEach(function(item) {
				let m = _.find(self.eventMarkers, function(o) {
					return o.id == `d_${item.id}`;
				});

				if (m == null) {
					m = new Marker();
					m.id = `d_${item.id}`;
					m.tripId = `d_${dataItem.id}`;
					m.infoWindowOptions = {
						infoWindowOpened: false,
						pixelOffset: {
							width: 0,
							height: -40
						},
						indexLoopSamePosition: 0
					};

					self.eventMarkers.push(m);

					m.position = new GeoPosition(item.position.lat, item.position.lon);
					m.description = item.data_category_description;
					m.zIndex = 0;

					var tooltipInfo = `<b class="header">${item.vehicle_name ? item.vehicle_name : "---"} - ${item[self.vehicleIdFilterFieldFormatted]}</b><br/>
						  <b class="driver">Conducente: ${item.driver_name ? item.driver_name : "---"}</b><br/><br/>
						  ${self.showPhoneNumber && item.mobile_phone_number ? '<span class="blackColor">TEL.: </span><a target="_blank" href="https://api.whatsapp.com/send?phone=' + item.mobile_phone_number + '">' + item.mobile_phone_number + '</a><br/>': '<span class="blackColor">TEL.: </span>ND<br/>'}
						  <span class="blackColor">${item.data_category_description}</span><br/>
						  ${item.value ? `<span class="blackColor">${item.value}</span><br/>` : ""}
						  <span class="lightGrey">${self.$options.filters.dateToString(item.event_date)} - ${self.$options.filters.timeToString(item.event_date)}</span><br/><br/>
						  <span class="gray-color">${item.position_display_name ? item.position_display_name + "</span><br/>" : ""}
						  <span class="gray-color"><span class="blackColor">LAT:</span> <span class="lightGrey">${item.position.lat}</span> - <span class="blackColor">LON:</span> <span class="lightGrey">${
						item.position.lon
					}</span></span><br/><br/>
						  <span class="gray-color"><span class="blackColor">Velocità:</span> <span class="lightGrey">${kendo.toString(item.speed, "n2")} km/h</span></span><br/>
						  <span class="gray-color"><span class="blackColor">Direzione:</span> <span class="lightGrey">${self.DirectionDegreeTocardinal(item.drive_direction)}</span></span><br/>`;
					m.info = tooltipInfo;

					var iconUrl = item.icon;

					if (iconUrl) {
						m.icon = {
							url: `/assets/diagnosis/${iconUrl}`, // url
							scaledSize: new google.maps.Size(20, 33), // scaled size
							origin: new google.maps.Point(0, 0) // origin
						};
					}
					m.infoWindowOptions.content = m.info;

					//manage same position
					self.checkForMarkerSamePosition(m);
				}
			});
		},

		addAlarmsMarkers: function(data) {
			var self = this;

			var dataItem = data.dataItem;
			var alarmsarkers = data.alarmsData;

			alarmsarkers.forEach(function(item, index) {
				let m = _.find(self.markers, function(o) {
					return o.id == item.id;
				});

				if (m == null) {
					m = new Marker();
					m.id = `a_${item.id}`;
					m.tripId = `a_${dataItem.id}`;
					m.infoWindowOptions = {
						infoWindowOpened: false,
						pixelOffset: {
							width: 0,
							height: -40
						},
						indexLoopSamePosition: 0
					};

					self.eventMarkers.push(m);

					m.position = new GeoPosition(item.position.lat, item.position.lon);
					m.description = item.description;
					m.zIndex = 0;
					m.info = `<b class="header">${item.vehicle_name ? item.vehicle_name : "---"} - ${item[self.vehicleIdFilterFieldFormatted]}</b><br/>
						  <b class="driver">Conducente: ${item.driver_name ? item.driver_name : "---"}</b><br/><br/>
						  ${self.showPhoneNumber && item.mobile_phone_number ? '<span class="blackColor">TEL.: </span><a target="_blank" href="https://api.whatsapp.com/send?phone=' + item.mobile_phone_number + '">' + item.mobile_phone_number + '</a><br/>': '<span class="blackColor">TEL.: </span>ND<br/>'}
						  <span class="blackColor">${item.description}</span><br/>
						  <span class="lightGrey">${self.$options.filters.dateToString(item.event_date)} - ${self.$options.filters.timeToString(item.event_date)}</span><br/><br/>
						  ${
								item.data && item.data.alarmType
									? '<span class="gray-color">Tipo:</span> <span class="lightGrey">' +
									  (self.settings.commonLabels["vehicle.event_alert_type." + item.data.alarmType]
											? self.settings.commonLabels["vehicle.event_alert_type." + item.data.alarmType]
											: item.data.alarmType) +
									  "</span><br/>" +
									  '<span class="gray-color">POI:</span> <span class="lightGrey">' +
									  item.alarm_poi_display_name +
									  "</span><br/><br/>"
									: ""
							}
						  <span class="gray-color">${item.position_display_name ? item.position_display_name + "</span><br/>" : ""}
						  <span><span class="blackColor">LAT:</span> <span class="lightGrey">${item.position.lat}</span> - <span class="blackColor">LON:</span> <span class="lightGrey">${
						item.position.lon
					}</span></span><br/><br/>
						  <span><span class="blackColor">Velocità:</span> <span class="lightGrey">${item.speed} km/h</span></span><br/>
						  <span><span class="blackColor">Direzione:</span> <span class="lightGrey">${self.DirectionDegreeTocardinal(item.drive_direction)}</span></span><br/>`;
					m.icon = {
						url: `/assets/alarms/icon/${item.type}-${item.subtype}.png`, // url
						scaledSize: new google.maps.Size(20, 33), // scaled size
						origin: new google.maps.Point(0, 0) // origin
					};
					m.infoWindowOptions.content = m.info;

					//manage same position
					self.checkForMarkerSamePosition(m);
				}
			});
		},

		checkForMarkerSamePosition(m) {
			//manage same position
			var self = this;
			var markersPathSamePosition = self.markers.filter(function(mm) {
				return mm.id != m.id && mm.position && mm.position.lat == m.position.lat && mm.position.lng == m.position.lng;
			});
			var eventMarkersSamePosition = self.eventMarkers.filter(function(mm) {
				return mm.id != m.id && mm.position && mm.position.lat == m.position.lat && mm.position.lng == m.position.lng;
			});

			var markersSamePosition = markersPathSamePosition.concat(eventMarkersSamePosition);

			if (markersSamePosition.length > 0) {
				var maxIndexOfLoop = self._.maxBy(markersSamePosition, "infoWindowOptions.indexLoopSamePosition");
				if (maxIndexOfLoop) {
					m.infoWindowOptions.indexLoopSamePosition = maxIndexOfLoop.infoWindowOptions.indexLoopSamePosition + 1;
				}
			}
		},

		addPoisMarkers: function(data) {
			var self = this;

			var dataItem = data.dataItem;
			var poisData = data.poisData;

			poisData.forEach(function(item, index) {
				if (item.location.rendering_type == "marker" || (item.location.rendering_type == "unknown" && item.location.points.length == 1)) {
					let m = _.find(self.poiTripMarkers, function(o) {
						return o.id == item.id;
					});

					if (m == null) {
						m = new google.maps.Marker();
						m.id = item.id;
						m.tripId = [];
						m.infoWindowOptions = {
							infoWindowOpened: false,
							pixelOffset: {
								width: 0,
								height: -40
							}
						};

						self.poiTripMarkers.push(m);
					}
					m.tripId.push(`ptm_${dataItem.id}`);
					m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
					m.title = item.name;
					m.info = `<b>${item.name}</b><br />
								LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
								INDIRIZZO: ${item.location.address}<br />`;
					if (item.poi_category_icon_image && !self.isInEditMode) {
						var icon = {
							url: item.poi_category_icon_image,
							scaledSize: new google.maps.Size(30, 36), // scaled size
							origin: new google.maps.Point(0, 0) // origin
						};
						m.icon = icon;
					}
					m.infoWindowOptions.content = m.info;
				} else if (item.location.rendering_type == "polygon" || (item.location.rendering_type == "unknown" && item.location.points.length > 1)) {
					//marker related to polygon
					let m = _.find(self.poiTripMarkers, function(o) {
						return o.id == item.id;
					});

					if (m == null) {
						m = new google.maps.Marker();
						m.id = item.id;
						m.tripId = [];
						m.infoWindowOptions = {
							infoWindowOpened: false,
							pixelOffset: {
								width: 0,
								height: -40
							}
						};

						self.poiTripMarkers.push(m);
					}
					m.tripId.push(`ptm_${dataItem.id}`);
					m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
					m.title = item.name;
					m.info = `<b>${item.name}</b><br />
								LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
								INDIRIZZO: ${item.location.address}<br />`;
					if (item.poi_category_icon_image) {
						var icon = {
							url: item.poi_category_icon_image,
							scaledSize: new google.maps.Size(30, 36), // scaled size
							origin: new google.maps.Point(0, 0) // origin
						};
						m.icon = icon;
					}
					m.infoWindowOptions.content = m.info;

					//polygon
					let p = _.find(self.poiTripPaths, function(o) {
						return o.id == item.id;
					});

					if (p == null) {
						p = {
							id: item.id,
							tripId: [],
							infoWindowOptions: {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: 0
								}
							}
						};

						self.poiTripPaths.push(p);
					}
					p.tripId.push(`ptp_${dataItem.id}`);
					p.fillColor = item.poi_category_fill_color;

					p.path = item.location.points.map(function(pt) {
						return new GeoPosition(pt.lat, pt.lon);
					});
					p.title = item.name;
					p.info = `<b>${item.name}</b><br />
								LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
								INDIRIZZO: ${item.location.address}<br />`;
					p.infoWindowOptions.content = p.info;
				} else if (item.location.rendering_type == "circle") {
					//marker related to circle
					if (!self.isInEditMode) {
						let m = _.find(self.poiTripMarkers, function(o) {
							return o.id == item.id;
						});

						if (m == null) {
							m = new google.maps.Marker();
							m.id = item.id;
							m.tripId = [];
							m.infoWindowOptions = {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: -40
								}
							};

							self.poiTripMarkers.push(m);
						}

						m.tripId.push(`ptm_${dataItem.id}`);
						m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
						m.title = item.name;
						m.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address || ""}<br />`;
						if (item.poi_category_icon_image) {
							var icon = {
								url: item.poi_category_icon_image,
								scaledSize: new google.maps.Size(30, 36), // scaled size
								origin: new google.maps.Point(0, 0) // origin
							};
							m.icon = icon;
						}
						m.infoWindowOptions.content = m.info;
					}
					//area
					let a = _.find(self.poiTripAreas, function(o) {
						return o.id == item.id;
					});

					if (a == null) {
						a = new google.maps.Circle();
						a.id = item.id;
						a.tripId = [];
						a.radius = item.radius;
						a.infoWindowOptions = {
							infoWindowOpened: false,
							pixelOffset: {
								width: 0,
								height: 0
							}
						};

						self.poiTripAreas.push(a);
					}

					a.tripId.push(`pta_${dataItem.id}`);
					a.fillColor = item.poi_category_fill_color;

					a.center = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);

					a.title = item.name;
					a.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
					a.infoWindowOptions.content = a.info;
				}
			});
		},
		removePath(dataItem) {
			//remove path
			var self = this;
			var indexPathToRemove = this.paths.findIndex(function(item) {
				return item.id == dataItem.id;
			});

			if (indexPathToRemove >= 0) {
				this.paths.splice(indexPathToRemove, 1);
			}
			//remove markers
			this._.remove(this.markers, function(item) {
				return item.id == dataItem.id;
			});
			this._.remove(this.tripMarkers, function(item) {
				return item.id == dataItem.id;
			});
			this._.remove(this.eventMarkers, function(item) {
				return item.tripId == `d_${dataItem.id}` || item.tripId == `a_${dataItem.id}`;
			});

			//remove TRIP POIS
			this._.remove(this.poiTripMarkers, function(item) {
				return item.tripId.length == 1 && item.tripId[0] == `ptm_${dataItem.id}`;
			});
			let tpms = this.poiTripMarkers.filter(function(item) {
				return item.tripId.find(tId => {
					return tId == `ptm_${dataItem.id}`;
				});
			});

			if (tpms && tpms.length > 0) {
				for (var i = 0; i < tpms.length; i++) {
					self._.remove(tpms[i].tripId, function(tId) {
						return tId == `ptm_${dataItem.id}`;
					});
				}
			}

			this._.remove(this.poiTripPaths, function(item) {
				return item.tripId.length == 1 && item.tripId[0] == `ptp_${dataItem.id}`;
			});

			let tpmp = this.poiTripPaths.filter(function(item) {
				return item.tripId.find(tId => {
					return tId == `ptp_${dataItem.id}`;
				});
			});

			if (tpmp && tpmp.length > 0) {
				for (var i = 0; i < tpmp.length; i++) {
					self._.remove(tpmp[i].tripId, function(tId) {
						return tId == `ptp_${dataItem.id}`;
					});
				}
			}

			this._.remove(this.poiTripAreas, function(item) {
				return item.tripId.length == 1 && item.tripId[0] == `pta_${dataItem.id}`;
			});

			let tpma = this.poiTripAreas.filter(function(item) {
				return item.tripId.find(tId => {
					return tId == `pta_${dataItem.id}`;
				});
			});
			if (tpma && tpma.length > 0) {
				for (var i = 0; i < tpma.length; i++) {
					self._.remove(tpma[i].tripId, function(tId) {
						return tId == `pta_${dataItem.id}`;
					});
				}
			}
		},
		removeDiagnosticMarkers(dataItem) {
			//remove markers
			this.eventMarkers = this.eventMarkers.filter(function(item) {
				return item.tripId != `d_${dataItem.id}`;
			});
		},
		removeAlarmsMarkers(dataItem) {
			//remove markers
			this.eventMarkers = this.eventMarkers.filter(function(item) {
				return item.tripId != `a_${dataItem.id}`;
			});
		},
		removePoisMarkers(dataItem) {
			//remove markers
			var self = this;
			this._.remove(this.poiTripMarkers, function(item) {
				return item.tripId.length == 1 && item.tripId[0] == `ptm_${dataItem.id}`;
			});
			this.poiTripMarkers = this.poiTripMarkers.filter(function(item) {
				return item.tripId.length != 1;
			});
			let tpms = this.poiTripMarkers.filter(function(item) {
				return item.tripId.find(tId => {
					return tId == `ptm_${dataItem.id}`;
				});
			});

			if (tpms && tpms.length > 0) {
				for (var i = 0; i < tpms.length; i++) {
					self._.remove(tpms[i].tripId, function(tId) {
						return tId == `ptm_${dataItem.id}`;
					});
				}
			}

			this._.remove(this.poiTripPaths, function(item) {
				return item.tripId.length == 1 && item.tripId[0] == `ptp_${dataItem.id}`;
			});
			this.poiTripPaths = this.poiTripPaths.filter(function(item) {
				return item.tripId.length != 1;
			});
			let tpmp = this.poiTripPaths.filter(function(item) {
				return item.tripId.find(tId => {
					return tId == `ptp_${dataItem.id}`;
				});
			});

			if (tpmp && tpmp.length > 0) {
				for (var i = 0; i < tpmp.length; i++) {
					self._.remove(tpmp[i].tripId, function(tId) {
						return tId == `ptp_${dataItem.id}`;
					});
				}
			}

			this._.remove(this.poiTripAreas, function(item) {
				return item.tripId.length == 1 && item.tripId[0] == `pta_${dataItem.id}`;
			});
			this.poiTripAreas = this.poiTripAreas.filter(function(item) {
				return item.tripId.length != 1;
			});
			let tpma = this.poiTripAreas.filter(function(item) {
				return item.tripId.find(tId => {
					return tId == `pta_${dataItem.id}`;
				});
			});
			if (tpma && tpma.length > 0) {
				for (var i = 0; i < tpma.length; i++) {
					self._.remove(tpma[i].tripId, function(tId) {
						return tId == `pta_${dataItem.id}`;
					});
				}
			}
		},
		removeAllPaths() {
			this.markers = [];
			this.eventMarkers = [];
			this.paths = [];
			this.poiTripMarkers = [];
			this.poiTripPaths = [];
			this.poiTripAreas = [];
		},
		DirectionDegreeTocardinal(deg) {
			if (deg > 11.25 && deg < 33.75) {
				return "N-NE";
			} else if (deg > 33.75 && deg < 56.25) {
				return "NE";
			} else if (deg > 56.25 && deg < 78.75) {
				return "E-NE";
			} else if (deg > 78.75 && deg < 101.25) {
				return "E";
			} else if (deg > 101.25 && deg < 123.75) {
				return "E-SE";
			} else if (deg > 123.75 && deg < 146.25) {
				return "SE";
			} else if (deg > 146.25 && deg < 168.75) {
				return "S-SE";
			} else if (deg > 168.75 && deg < 191.25) {
				return "S";
			} else if (deg > 191.25 && deg < 213.75) {
				return "S-SO";
			} else if (deg > 213.75 && deg < 236.25) {
				return "SO";
			} else if (deg > 236.25 && deg < 258.75) {
				return "O-SO";
			} else if (deg > 258.75 && deg < 281.25) {
				return "O";
			} else if (deg > 281.25 && deg < 303.75) {
				return "O-NO";
			} else if (deg > 303.75 && deg < 326.25) {
				return "NO";
			} else if (deg > 326.25 && deg < 348.75) {
				return "N-NO";
			} else {
				return "N";
			}
		}
		/*
		calculateAndDisplayRoute(path) {
			this.directionsService = new google.maps.DirectionsService();
			this.directionsRenderer = new google.maps.DirectionsRenderer();

			this.directionsRenderer.setMap(this.$refs.map.$mapObject);

			var self = this;
			var waypts = [];
			var points = helpers.decodeGooglePolyline(path);

			var coordinates = points.map(function(item) {
				return {
					lat: item[0],
					lng: item[1]
				};
			});
			for (var i = 0; i < coordinates.length; i++) {
				var point = coordinates[i];
				if (coordinates[i]) {
					waypts.push({
						location: new google.maps.LatLng(point.lat, point.lng),
						stopover: false
					});
				}
			}

			var startPoint = new google.maps.LatLng(coordinates[0].lat, coordinates[0].lng);
			var endPoint = new google.maps.LatLng(coordinates[coordinates.length - 1].lat, coordinates[coordinates.length - 1].lng);

			this.directionsService.route(
				{
					origin: startPoint,
					destination: endPoint,
					waypoints: waypts,
					optimizeWaypoints: true,
					travelMode: "DRIVING"
				},
				function(response, status) {
					if (status === "OK") {
						console.log(response);
						self.directionsRenderer.setDirections(response);
					} else {
						window.alert("Directions request failed due to " + status);
					}
				}
			);
		}
		*/
	},
	computed: {
		...mapGetters(["settings"])
	}
};
